import { render, staticRenderFns } from "./EditLottoRate.vue?vue&type=template&id=a9a167c4&"
import script from "./EditLottoRate.vue?vue&type=script&lang=js&"
export * from "./EditLottoRate.vue?vue&type=script&lang=js&"
import style0 from "./EditLottoRate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports